export const FETCH_RWAMEMBER_INIT_ACTION = "FETCH_RWAMEMBER_INIT_ACTION";
export const FETCH_RWAMEMBER_SUCCESS_ACTION =
  FETCH_RWAMEMBER_INIT_ACTION + "_SUCCESS";
export const FETCH_RWAMEMBER_FAIL_ACTION =
  FETCH_RWAMEMBER_INIT_ACTION + "_ERROR";

export const ADD_RWAMEMBER_INIT_ACTION = "ADD_RWAMEMBER_INIT_ACTION";
export const ADD_RWAMEMBER_SUCCESS_ACTION =
  ADD_RWAMEMBER_INIT_ACTION + "_SUCCESS";
export const ADD_RWAMEMBER_FAIL_ACTION =
  ADD_RWAMEMBER_INIT_ACTION + "_ERROR";

  export const DELETE_RWAMEMBER_INIT_ACTION = "DELETE_RWAMEMBER_INIT_ACTION";
export const DELETE_RWAMEMBER_SUCCESS_ACTION =
  DELETE_RWAMEMBER_INIT_ACTION + "_SUCCESS";
export const DELETE_RWAMEMBER_FAIL_ACTION =
  DELETE_RWAMEMBER_INIT_ACTION + "_ERROR";

  export const UPDATE_RWAMEMBER_INIT_ACTION = "UPDATE_RWAMEMBER_INIT_ACTION";
export const UPDATE_RWAMEMBER_SUCCESS_ACTION =
UPDATE_RWAMEMBER_INIT_ACTION + "_SUCCESS";
export const UPDATE_RWAMEMBER_FAIL_ACTION =
UPDATE_RWAMEMBER_INIT_ACTION + "_ERROR";
